import { render, staticRenderFns } from "./StorageRequestDialog.vue?vue&type=template&id=e65725a0&scoped=true"
import script from "./StorageRequestDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./StorageRequestDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./StorageRequestDialog.vue?vue&type=style&index=0&id=e65725a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e65725a0",
  null
  
)

export default component.exports